import React, { createRef, useState } from 'react';
import PropTypes from 'prop-types';

import { BorderRadius, Colors, FontSizes, FontWeights } from '../Theme';

const SsnInput = ({ invalid, onChange, required, value }) => {
  const [parts, setParts] = useState({
    part_one: value.substring(0, 3),
    part_two: value.substring(3, 5),
    part_three: value.substring(5, 9)
  });
  const [inputFocus, setInputFocus] = useState(false);
  const input1 = createRef();
  const input2 = createRef();
  const input3 = createRef();
  const focus_color = inputFocus ? '#aaaaaa' : '#e5e5e5';
  const border_color = invalid ? Colors.RED.hex : focus_color;
  const styles = {
    component: {
      backgroundColor: '#fff',
      borderRadius: BorderRadius.DEFAULT,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: border_color,
      fontSize: FontSizes.MEDIUM,
      position: 'relative',
      height: 40,
      lineHeight: '20px',
      padding: 10,
      display: 'flex'
    },
    input: {
      fontSize: FontSizes.MEDIUM,
      fontWeight: FontWeights.REGULAR,
      lineHeight: '20px',
      backgroundColor: 'transparent',
      border: 'none',
      color: Colors.GRAY.hex,
      padding: 0,
      margin: 0,
      textIndent: 0,
      boxShadow: 'none',
      outline: 'none',
      width: '100%',
      height: 20,
      fontStyle: 'normal',
      WebkitAppearance: 'none'
    },
    required: {
      color: Colors.RED.hex,
      position: 'absolute',
      right: 5,
      top: 5,
      lineHeight: '1',
      fontSize: FontSizes.LARGE
    }
  };

  const handleInputChange = (name, e) => {
    let value = `${e.nativeEvent.target.value}`.replace(/[^0-9]/g, '');

    if (name === 'part_one') {
      value = value.substring(0, 3);

      if (value.length === 3) {
        input2.current.focus();
      }
    } else if (name === 'part_two') {
      value = value.substring(0, 2);

      if (value.length === 2) {
        input3.current.focus();
      }

      if (value.length === 0) {
        input1.current.focus();
      }
    } else {
      value = value.substring(0, 4);

      if (value.length === 0) {
        input2.current.focus();
      }
    }

    setParts({ ...parts, [name]: value }, () => {
      if (onChange) {
        onChange(`${parts.part_one}${parts.part_two}${parts.part_three}`);
      }
    });
  };

  return (
    <div style={styles.component}>
      <input
        onBlur={setInputFocus.bind(null, false)}
        onChange={handleInputChange.bind(null, 'part_one')}
        onFocus={setInputFocus.bind(null, true)}
        ref={input1}
        style={Object.assign({}, styles.input, { width: 25 })}
        type='password'
        value={parts.part_one}
      />
      -
      <input
        onBlur={setInputFocus.bind(null, false)}
        onChange={handleInputChange.bind(null, 'part_two')}
        onFocus={setInputFocus.bind(null, true)}
        ref={input2}
        style={Object.assign({}, styles.input, { width: 30, textAlign: 'center' })}
        type='password'
        value={parts.part_two}
      />
      -
      <input
        onBlur={setInputFocus.bind(null, false)}
        onChange={handleInputChange.bind(null, 'part_three')}
        onFocus={setInputFocus.bind(null, true)}
        ref={input3}
        style={Object.assign({}, styles.input, { marginLeft: 10 })}
        type='text'
        value={parts.part_three}
      />
      {required ? <span style={styles.required}>*</span> : null}
    </div>
  );
};

SsnInput.propTypes = {
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SsnInput;
